import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import './OpenAlerts.scss';

class OpenAlerts extends Component {
    componentDidMount() {
        // eslint-disable-next-line no-undef
        const originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
        // eslint-disable-next-line no-undef
        Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
            draw: function() {
                originalDoughnutDraw.apply(this, arguments);

                const chart = this.chart.chart;
                const ctx = chart.ctx;
                const width = chart.width;
                const height = chart.height;

                const fontSize = (height / 150).toFixed(2);
                ctx.font = fontSize + 'em Verdana';
                ctx.textBaseline = 'middle';

                const text = chart.config.data.text;
                let measureText = ctx.measureText(text);
                const textX = Math.round((width - measureText.width) / 2);
                const textY =
                    (chart.chartArea.top + chart.chartArea.bottom) / 2;

                ctx.fillText(text, textX, textY);
            }
        });
    }

    // todo [mandy] need to work out the following from the openAlerts:
    // 1. assert the number of pie charts needed with the info of rule classification sent. max is 4
    // 2. Work out the percentage of each rule sent back
    // 3. display in piechart
    // 4. need to have a list of colors which are to be used in the piechart (say have 10 colors for now).

    options = {
        responsive: true,
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                boxWidth: 10
            }
        },
        cutoutPercentage: 88,
        title: {
            display: false,
            text: '' // todo make this dynamic
            // fontColor: 'var(--blue)' // todo color with variable not working
        }
    };

    extractPercentage() {
        let totalOpenAlerts = 0;
        this.props &&
            this.props.data['Anti Money Laundering'] &&
                this.props.data['Anti Money Laundering'].forEach(
                    x => (totalOpenAlerts += x.openAlerts)
                );

        // console.log(totalOpenAlerts);
        let labels = [];
        let data = [];
        this.props &&
            this.props.data['Anti Money Laundering'] &&
            (this.props.data['Anti Money Laundering'] || []).forEach(x => {
                labels.push(x.friendlyType);

                totalOpenAlerts > 0
                    ? data.push(
                          Math.round((x.openAlerts / totalOpenAlerts) * 100)
                      )
                    : data.push(100);
            });

        return {
            text: totalOpenAlerts,
            labels: labels,
            datasets: [
                {
                    data: data,
                    // backgroundColor: ['#7B8293', '#2B5BE2', '#27C341', '#F4F4F6', '#E9F9EC', '#33353D']
                    backgroundColor: [
                        '#7B8293',
                        '#2B5BE2',
                        '#29e5db',
                        '#c1c1c1',
                        '#23abf9'
                    ]
                }
            ]
        };
    }

    render() {
        let data = this.extractPercentage();
        return (
            <div className="pie-chart">
                <Doughnut data={data} options={this.options} />
            </div>
        );
    }
}

export default OpenAlerts;
